import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
import { whatsappUrl } from '../../data/contact';
export function FinalCta() {
  const {
    t
  } = useLanguage();
  return <section id="consultation" className="relative overflow-hidden bg-ink py-24 sm:py-32" aria-labelledby="final-cta-heading" data-id="element-90" data-mp="1so2qqekoqa8v">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[620px] w-[620px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand/[0.16] blur-3xl" aria-hidden="true" data-id="element-91" data-mp="1eo1qn1c8v6ug" />
      <div className="relative mx-auto max-w-shell px-5 sm:px-8" data-id="element-92" data-mp="14qncx9hpgw5u">
        <Reveal data-id="element-93" data-mp="14s84qrcmy100">
          <div className="glass-dark mx-auto max-w-[860px] rounded-4xl border border-white/12 px-6 py-14 text-center shadow-lift sm:px-14 sm:py-20" data-id="element-94" data-mp="19p72djvicq2y">
            <h2 id="final-cta-heading" className="headline mx-auto max-w-[680px] text-[34px] font-bold text-white sm:text-[52px]" data-id="element-95" data-mp="2z5g48wbk30rz">
              {t.finalCta.heading}
            </h2>
            <p className="mx-auto mt-7 max-w-[540px] text-[17px] leading-relaxed text-white/65 sm:text-[19px]" data-id="element-96" data-mp="2838wwbalqqx">
              {t.finalCta.subtitle}
            </p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="group mt-10 inline-flex items-center gap-2.5 rounded-2xl bg-brand px-9 py-5 text-[16px] font-semibold text-white shadow-glow transition-all duration-300 hover:-translate-y-1 hover:bg-brand-600 sm:text-[17px]" data-id="element-97" data-mp="b1f53d4qs34o">
              {t.form.submit}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="3ahbwjp8rudq5" />
            </a>
            <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-99" data-mp="3oe8hja27l0z4">
              {t.finalCta.assurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-100" data-mp="13pu9z6u5t52a">
                  <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-101" data-mp="13s6yk2ufadob" />
                  <span className="text-[14px] font-medium text-white/70" data-id="element-102" data-mp="yqhkeebwljw0">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}